export const LOW_MARGIN_THRESHOLD = 50;
export const LOW_MARGIN_MESSAGE =
  'You have entered a Target Margin value that is below the average Margin set for this account. We recommend reviewing the Banked Margin for the project before you confirm you want to proceed';
export const MARGIN_UPDATE_NOT_ALLOWED_ERROR =
  'New Margin value cannot be set in a non Target Margin survey.';
export const EMPTY_MARGIN_VALUE = 'New Margin value cannot be empty or 0.';
